import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageDimension',
})
export class ImageDimensionPipe implements PipeTransform {
  transform(
    value: File | string | null,
    type: 'width' | 'height',
  ): Promise<number> {
    if (!value) return Promise.resolve(0);

    return new Promise<number>((resolve) => {
      const img = new Image();

      if (typeof value === 'string') {
        img.src = value;
      } else if (value instanceof File && value.type.startsWith('image/')) {
        img.src = URL.createObjectURL(value);
      } else {
        resolve(0);
        return;
      }

      img.onload = () => {
        resolve(type === 'width' ? img.width : img.height);
      };
    });
  }
}
